import './App.css';
import { ParentComponent } from './Components/ParentComponent';

function App() {
  return (
    <div>
     <ParentComponent />
    </div>
  );
}

export default App;
